import { useSessionTracking } from '@/hooks/useSessionTracking';

export function SessionTracker({ children }: { children: React.ReactNode }) {
  useSessionTracking();
  return <>{children}</>;
}
